function initModal(): void {
  const openModalButtons = document.querySelectorAll(".open-modal");
  const closeModalButtons = document.querySelectorAll(".modal__close");

  const openModal = (modal: HTMLElement) => {
    modal.style.display = "block";
    requestAnimationFrame(() => {
      modal.setAttribute("aria-hidden", "false");
      modal.style.opacity = "1";
      document.body.style.overflow = "hidden"; // Prevent background scrolling
      const modalContainer = modal.querySelector(".modal__container");
      if (modalContainer) {
        modalContainer.scrollTop = 0; // Reset scroll position to top
      }
      const firstFocusableElement = modal.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      );
      if (firstFocusableElement) {
        (firstFocusableElement as HTMLElement).focus();
      }
    });
  };

  const closeModal = (modal: HTMLElement) => {
    const activeElement = document.activeElement as HTMLElement;
    modal.style.opacity = "0";
    activeElement.focus();
    setTimeout(() => {
      modal.setAttribute("aria-hidden", "true");
      modal.style.display = "none";
      document.body.style.overflow = ""; // Restore background scrolling
    }, 300); // Match the transition duration in CSS
  };

  openModalButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const target = event.currentTarget as HTMLElement;
      const modalId = target.getAttribute("aria-controls");
      const modal = document.getElementById(modalId!);
      if (modal) {
        openModal(modal);
      }
    });
  });

  closeModalButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const modal = button.closest(".modal") as HTMLElement;
      if (modal) {
        closeModal(modal);
      }
    });
  });

  document.querySelectorAll(".modal").forEach((modal) => {
    const overlay = modal.querySelector(".modal__overlay");
    if (overlay) {
      overlay.addEventListener("click", (event) => {
        if (event.target === overlay) {
          closeModal(modal as HTMLElement);
        }
      });
    }
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        document.querySelectorAll(".modal[aria-hidden='false']").forEach((modal) => {
          closeModal(modal as HTMLElement);
        });
      }
    });
  });
}

export { initModal };
